export const painPoints = [
  {
    emoji: '😱',
    title: 'You study for hours and go blank in the exam',
    desc: 'You read and highlight everything, but when it is time to perform you feel like you forgot everything you studied.',
  },
  {
    emoji: '🌙',
    title: 'You retake subjects you thought you had covered',
    desc: 'You fall one point short of passing and do not understand why, after dedicating entire weeks to preparing for it.',
  },
  {
    emoji: '🎭',
    title: 'Panic paralyzes you during oral exams',
    desc: 'You know the material but standing in front of the examiner the words do not come out — and they notice it immediately.',
  },
  {
    emoji: '🔍',
    title: 'You always start preparing too late',
    desc: 'The semester flies by and suddenly you have 5 exams in one week without having started any of them seriously.',
  },
  {
    emoji: '💔',
    title: "You depend entirely on other people's notes",
    desc: 'If nobody who already passed the subject shows up, you do not know where to start or what is actually important.',
  },
  {
    emoji: '🔁',
    title: 'You finish exhausted and the next semester starts the same',
    desc: 'You are a slave to borrowed notes and stacked finals, not the owner of your own academic performance.',
  },
];
